


























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ContabilOrcamentoFrotaService from "@/service/ContabilOrcamentoFrotaService";
import { RelatorioOrcamentoFrotaModel } from "@/models/contabil/orcamento-frota/RelatorioOrcamentoFrotaModel" ;
import { ConsultarOrcamentoFrotaModel } from "@/models/contabil/orcamento-frota/ConsultarOrcamentoFrotaModel" ;
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { orcamentoAutoOnlineService } from "@/service/orcamento-auto-online/OrcamentoAutoOnlineService";
import { ClienteFrotaDTO} from "@/models/orcamento-auto-online/ClienteFrotaModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog
  }
})
export default class FaturamentoBruto extends Vue {

     $refs!: {
        relatorioObserver: InstanceType<typeof ValidationObserver>;
    };

    loading:boolean = false;
    valores: ConsultarOrcamentoFrotaModel[] = [];

    mounted() {
        this.oberClientesFrota();
    }

    acaoDialog() {
        this.openDialog = false;
    }

    openDialog = false;
    dialogTitle = "";
    dialogMessage = "";
    dialogStyle = "";
    dialogType = "";
    dialogKey = 0;
    clientesFrota: ClienteFrotaDTO[] = [];

    relatorio: RelatorioOrcamentoFrotaModel  =  {
        inicio: undefined,
        fim: undefined,
        naturezaServico: { valor: undefined, descricao: "Todas" },
        cliente: { id: 0, nome: "Clientes" },
        status: undefined
    }


    tiposNaturezaServico = [
        { valor: undefined, descricao: "Todas" },
        { valor: "ASSISTENCIA_24H", descricao: "Assistência 24h" },
        { valor: "ORCAMENTO_AUTOMOTIVO", descricao: "Orçamento Automotivo Online" },
    ]

    listaStatusPagamento = [
        { valor: undefined, descricao: "Todos" },
        { valor: "PAGO", descricao: "Pago" },
        { valor: "PEND", descricao: "Pendente" },
    ]

    statusPagamento =  { valor: undefined, descricao: undefined };

    cabecalho = [
        { text: "Data", value: "dataEmissao", width: '120px' },
        { text: "Orçamento", value: "numeroOrcamento", width: '150px'},
        { text: "Cliente", value: "nomeCliente", width: '300px'},
        { text: "Associado", value: "associado", width: '300px'},
        { text: "CPF/CNPJ", value: "cpfCnpj", width: '150px'},
        { text: "Agente", value: "agente", width: '300px'},
        { text: "Natureza Serviço", value: "naturezaServico", width: '150px'},
        { text: "Status", value: "status", width: '250px'},
        { text: "Valor Bruto", value: "valorBruto", width: '100px'}
    ]

    gerarRelatorio() {
        this.$refs.relatorioObserver.validate().then((valid: boolean) => {
            if(valid) {
                this.loading = true;

                if (this.statusPagamento) {
                    this.relatorio.status = this.statusPagamento.valor;
                }

                ContabilOrcamentoFrotaService.gerarRelatorio(this.relatorio).then(res => {

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));

                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                fileLink.setAttribute('download', 'relatorio_orcamento_frota.pdf');

                document.body.appendChild(fileLink);

                fileLink.click();

                this.loading = false;

                }).catch(err => {
                     this.loading = false;
                    this.dialogTitle = "Ocorreu um erro ao gerar o relatório";
                    this.dialogMessage = err.message;
                    this.dialogStyle = "error";
                    this.openDialog = true;

                });

                this.limparformulario();
            }
            
        });    
    }

    consultar() {
        if (this.statusPagamento) {
            this.relatorio.status = this.statusPagamento.valor;
        }
        this.loading = true;
        ContabilOrcamentoFrotaService
        .consultarRelatorioOrcamentoFrota(this.relatorio
        ).then((res) => {
            this.valores = res.data;
            this.loading = false;
        })
        .catch((err) => {
            this.loading = false;
            console.log(err);
        });
  }
    
    gerarRelatorioExcel() {
        this.$refs.relatorioObserver.validate().then((valid: boolean) => {
            
            if(valid) {
                this.loading = true;
                if (this.statusPagamento) {
                    this.relatorio.status = this.statusPagamento.valor;
                }
                ContabilOrcamentoFrotaService.gerarRelatorioExcel(this.relatorio).then(res => {

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));

                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                fileLink.setAttribute('download', 'relatorio_orcamento_frota.xls');

                document.body.appendChild(fileLink);

                fileLink.click();

                this.loading = false;

                }).catch(err => {
                     this.loading = false;
                    this.dialogTitle = "Ocorreu um erro ao gerar o relatório";
                    this.dialogMessage = err.message;
                    this.dialogStyle = "error";
                    this.openDialog = true;

                });

                this.limparformulario();
            }
            
        });
    }

    oberClientesFrota() {
        this.loading = true;
        this.clientesFrota = [];
        orcamentoAutoOnlineService
        .obterClientesFrota().then((res: ClienteFrotaDTO[]) => {
            this.clientesFrota = res;
            this.loading = false;
        })
        .catch((err) => {
            this.loading = false;
            console.log(err);
        });
    }

    limparformulario() {
        this.relatorio = {
            inicio: undefined,
            fim: undefined,
            naturezaServico: undefined,
        }
        this.$refs.relatorioObserver.reset();
    }
    
}
